import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
} from '@mui/material';

const RM_third = () => {
  return (
    <Box
      sx={{
        width: '95%',
        py: 2,
        display: 'flex',
        gap: 2,
        boxSizing: 'border-box',
      }}
    >
      {/* Validation Checks */}
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600} sx={{ color: '#242424' }} >
          Multi-Angle Reconciliation
        </Typography>

        <Typography variant="body2" mt={1}>
          Every estimate is validated via multi-angle reconciliation:
        </Typography>

        <List dense disablePadding sx={{ mt: 1 }}>
          {[
            'Demand-Side: Consumer drivers, usage patterns, purchasing behavior',
            'Supply-Side: Manufacturing capacity, distribution reach, price benchmarks',
            'External Checks: Trade flows, sector growth indicators, import/export data',
          ].map((text, idx) => (
            <ListItem key={idx} disableGutters>
              <ListItemText primary={`• ${text}`} />
            </ListItem>
          ))}
        </List>
      </Box>

      {/* Finalization Criteria */}
      <Box
        sx={{
          flex: 1,
          p: 2,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600} sx={{ color: '#242424' }} >
          Finalization Criteria
        </Typography>

        <Typography variant="body2" mt={1}>
          Only cross-verified data that aligns across three or more independent sources is deemed final and publishable.
        </Typography>
      </Box>
    </Box>
  );
};

export default RM_third;
